const en = {
  translation: {
    language: { label: 'Interface language', ru: 'Russian', en: 'English', bg: 'Bulgarian' },
    navigation: {
      close: 'Close',
      account: 'Dashboard',
      products: 'Products / Licenses',
      finance: 'My finances',
      calculator: 'Calculator',
      partners: 'For partners',
      events: 'Events',
      profile: 'Personal details',
      support: 'Support',
      promo: 'Promo',
      vps: 'VPS',
      logout: 'Log out',
    },
    header: { promotion: 'Promotion', balance: 'Balance', technicalSupport: 'Technical support', mentor: 'Mentor' },
    profile: {
      main: 'General information',
      fullName: 'Full name',
      loginUsername: 'Login (username)',
      birthDate: 'Date of birth',
      country: 'Country',
      email: 'Email',
      phone: 'Phone',
      telegram: 'Telegram',
      security: 'Security',
      transactionConfirmation: 'Transaction confirmation',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      enterOldPassword: 'Enter your old password',
      enterNewPassword: 'Enter your new password',
      confirmPassword: 'Confirm your password',
      invalidPasswordCharacter: 'An invalid character was used. Allowed: Latin letters, numbers, and !@#$%^&*()-+',
      passwordComplexity:
        'Password must contain at least 2 of 4: lowercase letters, uppercase letters, numbers, special characters',
      passwordsMustMatch: 'Passwords must match!',
      save: 'Save',
      lastName: 'Last name',
      firstName: 'First name',
      middleName: 'Middle name',
      enterLastName: 'Enter your last name',
      enterFirstName: 'Enter your first name',
      enterMiddleName: 'Enter your middle name',
      lastNameExample: 'Smith',
      firstNameExample: 'John',
      middleNameExample: 'James',
      phoneFormat: 'Phone must be in the +79997768879 format',
      phoneLength: 'Phone must contain 11 to 15 digits',
      telegramRequirements: 'Telegram must contain only Latin characters, start with @, and be 5 to 31 characters long',
      enterPhoneNumber: 'Enter your phone number',
      enterTelegramNickname: 'Enter your Telegram nickname',
      countryPlaceholder: 'Greece',
      moscow: 'Moscow',
      confirmationByEmail: 'By email',
      googleAuthenticator: '2FA Google Authenticator',
      error: 'Error',
      phoneRequiredForTwoFactor: 'Add a phone number in your profile settings.',
    },
    verification: {
      title: 'Verification',
      passportPhotoRequired: 'To verify your account, upload a photo of your passport',
      instruction: 'Instructions',
      takePhotoAsExample: 'Take a photo as shown in the example',
      addPhotoToForm: 'Add the photo to the form',
      sendForReviewInstruction: 'Click “Send for review”',
      mainPassportSpread: '1. Main passport spread',
      registrationAddress: '2. Registration address',
      addPhoto: 'Add a photo',
      chooseFile: 'Choose file',
      photoRequirements: 'Photo requirements',
      takesUpToFiveDays: 'Verification takes up to 5 days',
      send: 'Send',
      sendForReview: 'Send for review',
      documentsUnderReview: 'Documents under review',
      verificationError: 'Verification error',
      repeatVerificationRequired: 'You need to complete verification again',
      repeatVerification: 'Repeat verification',
      startVerification: 'Start verification',
    },
    accountRemoval: {
      removeAllData: 'Delete my account and all data',
      title: 'Delete account',
      confirmation: 'Are you sure you want to delete your account and all data? ',
      remove: 'Delete',
      informationalNotice: 'Information notice',
      reasonNoLongerClient: 'I no longer want to be a client',
      reasonAnotherAccount: 'I want to create another account',
      reasonOther: 'Other reasons',
      warnings: 'Warnings',
      warningIrreversible: 'Deleting your personal account means you will no longer be able to restore your data',
      warningBalance: 'All your progress and funds in your balance will be deleted',
      warningProducts: 'You will no longer be able to use the company products purchased for this account',
      warningsAcknowledged: 'I have read the warnings',
      codeSentToEmail: 'Enter the code we sent to your email',
      removeAccount: 'Delete account',
    },
    finance: {
      balance: 'Balance:',
      processing: 'Processing:',
      inProcessing: 'In progress',
      withdrawn: 'Withdrawn:',
      transactionHistory: 'Transaction history',
      completed: 'Completed',
      cancelled: 'Cancelled',
      transactionId: 'Transaction ID',
      recipient: 'Recipient',
      sender: 'Sender',
      description: 'Description',
      paymentMethod: 'Payment method',
      cancelTransaction: 'Cancel transaction',
      noTransactions: 'No transactions',
      cancellationConfirmation: 'Confirm transaction cancellation',
      yes: 'Yes',
      filter: 'Filter',
      byDate: 'By date',
      enterUsername: 'Enter username',
      enterDescription: 'Enter description',
      selectPaymentMethod: 'Select a payment method',
      show: 'Show',
      purchase: 'Purchase',
      withdrawal: 'Withdrawal',
      matchingBonus: 'Matching bonus',
      companyReward: 'Company reward',
      other: 'Other',
      withdrawalNotice: 'Withdrawal may take up to two business days ',
      instruction: 'Instructions',
      withdrawalStepDetails: 'Enter the network, wallet address, and withdrawal amount',
      withdrawalStepVerify: 'Confirm that the details are correct ',
      withdrawalStepConfirm: 'Confirm the transaction ',
      chooseCoin: 'Select a coin',
      coin: 'Coin',
      chooseNetwork: 'Select a network',
      cryptocurrencyNetwork: 'Cryptocurrency network',
      walletAddressInNetwork: 'Enter the wallet address for the selected network',
      enterWalletAddress: 'Enter wallet address',
      enterAmount: 'Enter amount',
      minimumWithdrawalAmount: 'Minimum withdrawal amount: {{amount}}',
      minimumWithdrawalError: 'Minimum withdrawal amount: {{amount}} USDT',
      walletLengthError: 'Wallet address exceeds 50 characters',
      invalidAmount: 'You entered an invalid amount',
      invalidIntegerAmount: 'You entered an invalid amount. The withdrawal amount must be a whole number',
      insufficientFunds: 'Insufficient funds in your account',
      withdrawBonuses: 'Withdraw bonuses',
    },
    notifications: {
      title: 'Notifications',
      empty: 'No notifications',
      dateTime: '{{date}} at {{time}}',
    },
    events: {
      online: 'Online',
      offline: 'Offline',
      readMore: 'Read more',
      title: 'Events',
      back: 'Back',
      nextArticle: 'Next article',
      futureEvents: 'Upcoming events',
      pastEvents: 'Past events',
    },
    marketing: {
      title: 'Marketing',
      description:
        'In this section, you can explore all the rules and conditions for earning rewards for promoting the company’s products, as well as the information you need to build an online business.',
      companyPlanTitle: 'FT Holding Trade company marketing plan',
      companyPlanDescription:
        'In this section, you can explore all the rules and conditions for earning rewards for promoting the company’s products, as well as the information you need to build an online business.',
      goTo: 'Go to',
      readMore: 'Read more',
      materials: {
        fastStart: {
          title: 'Quick Start Bonus',
          summary:
            'This is an additional percentage for personal referrals. To receive the Quick Start bonus, you need to purchase 1, 3, or 5 trading systems...',
          sections: [
            `This is an additional percentage for personal referrals.

To receive the Quick Start bonus, you need to purchase 1, 3, or 5 trading systems.
The company also offers the Quick Start bonus, which is valid for the first 30 days after purchasing a trading system.

When you purchase one trading system, you receive an additional 3% income from each personal sale.

If you purchase 3 trading systems, you receive an additional 6% income from each personal sale. If you purchase 5 trading systems, you receive an additional 9% income from each personal sale.`,
          ],
        },
        matchingBonus: {
          title: 'Matching Bonus',
          summary:
            'The Matching Bonus is paid to you from every sale in your structure. Starting from level 5, each partner receives Director status...',
          sections: [
            `The Matching Bonus is paid to you from every sale in your structure.
Starting from level 5, each partner receives Director status...
They receive a unique structure ID and the Matching Bonus.
The Matching Bonus is paid to you from every sale in your structure.
This bonus is paid together with the team bonus.
The amount ranges from 0.5% to 5% from each sale, depending on your level.
When another level 5 Director appears in your structure, they also begin receiving the Matching Bonus from their structure, creating a difference in income for you.
If your partner is at level 5, they receive a 0.5% Matching Bonus from their entire structure.
You will then receive your percentage minus this 0.5% from that branch of the structure.
If the partner is at level 6, they receive a 1% Matching Bonus from their structure, and you receive 1% less from that structure.
If a partner below you reaches the same career level as you, you stop earning from their structure because there is no longer a difference between your levels, and that partner receives all the bonuses.
This rule applies to both the team bonus and the Matching Bonus.`,
          ],
        },
        units: {
          title: 'Unit Calculation',
          summary:
            'The company has a ranking system called Career Levels. Career Levels are achieved through sales of the company’s products made by you and your partners...',
          sections: [
            `The company has a ranking system called Career Levels. Career Levels are achieved through sales of the company’s products made by you and your partners.

To advance to the next level, you need to earn a certain number of Units.

A Unit is a measurement that represents the sales turnover generated by a partner and their team within the company and determines the level each partner should hold according to their turnover.`,
            `The company uses a formula that allows you to calculate how many Units you will receive from the sale of any company product.

PRODUCT PRICE / 500 = number of Units.

In other words, divide the customer’s purchase amount by the coefficient of 500 to obtain the number of Units earned from the turnover.
How are turnover and Units calculated?

The company uses a formula that allows you to calculate how many Units you will receive from the sale of any company product.

PRODUCT PRICE / 500 = number of Units.

In other words, divide the customer’s purchase amount by the coefficient of 500 to obtain the number of Units earned from the turnover.`,
          ],
        },
        career: {
          title: 'How to Unlock the FT Holding Trade Career',
          summary:
            'The first requirement is an active status that gives you access to the business and allows you to advance through the career levels. The second requirement is owning trading systems that unlock every level of the company’s marketing plan. The company has two requirements: an active status that gives you access to the business and career growth, and trading systems that unlock all levels of the marketing plan.',
          sections: [
            `Let us take a closer look at the first requirement:

The career program has 11 levels, starting from level 0 and ending at level 10.

To receive level 0, you only need to register an account through a company partner’s referral link. Immediately after registration, you can begin building your business and earn 15% of the price of any product.
This is a starter level for all company partners who want to begin building a business but, for various reasons, cannot yet purchase a trading system.
To advance to level 1, you need to purchase one trading system or the Professional package at the trading school.

By purchasing one of these products, you receive one year of access to the company’s business career program.

If you purchase 2 trading systems, you immediately receive 2 years of access to the company’s career program.

If you purchase 5 trading systems, you receive 5 years of access to the company’s career program, and so on.

1 trading system = an additional 365 days of access to the company’s career program.
Now let us look at the second requirement:

Owning 1 trading system unlocks career levels 1 through 4. This means you can advance to level 4 within 365 days. To continue advancing and earn more, you need to purchase 2 additional trading systems.

Owning 3 trading systems unlocks career levels 1 through 7. This gives you 3 years to reach level 7.`,
            `To unlock all 10 levels, you need to purchase 5 trading systems. This activates all 10 career levels, gives you access to the marketing plan for 5 years, and allows you to earn up to 45% of the product price from each personal sale.

Trading systems can be purchased as you advance through the levels.

Trading system licences are perpetual, so once purchased, they remain yours permanently.

To learn how to advance through the career program and reach new levels, we recommend watching the video on the main Marketing page.`,
          ],
        },
      },
    },
    partners: {
      structureTree: 'Structure tree',
      resetFilter: 'Reset filter',
      selectSortingMethod: 'Select a sorting method',
      loginOrPartnerEmail: 'Partner login or email',
      partnerId: 'Partner ID',
      qualification: 'Qualification',
      personalSales: 'Personal sales',
      applyFilter: 'Apply filter',
      firstLinePartnersCount: 'Number of partners in the first line',
      noPartners: 'No partners',
      dataNotFound: 'No data found',
      partnerLinks: 'Partner links',
      partnerLinksHint: 'Create partner links for quick access.',
      addPartnerLink: 'Add partner link',
      editPartnerLink: 'Edit partner link',
      companyName: 'Company name',
      enterCompanyName: 'Enter company name',
      pasteLink: 'Paste the link',
      enterLink: 'Enter the link',
      add: 'Add',
      edit: 'Edit',
      maximumCharacters: 'Maximum {{count}} characters',
      deleteLinkTitle: 'Confirm link deletion',
      deleteLinkDescription: 'Are you sure you want to delete the link?',
      yes: 'Yes',
      fastStartBonus: 'Fast Start bonus',
      daysRemaining: '{{count}} days remaining',
      nextQualification: 'Next qualification',
      progress: 'Progress',
      teamSales: 'Team sales',
      incomePercentage: 'My income percentage',
      matchingBonus: 'Matching bonus',
      technicalSupportUntil: 'Technical support until:',
      technicalSupport: 'Technical support:',
      inactive: 'Inactive',
    },
    statistics: {
      personalRegistrations: 'Personal registrations',
      personalSales: 'Personal sales',
      teamRegistrations: 'Team registrations',
      teamSales: 'Team sales',
      salesAndRegistrationsDynamics: 'Personal and team sales and registration trends.',
      showAllLines: 'Show all {{count}} lines',
      lines: 'Lines',
      line: 'Line {{count}}',
      noOpenLines: 'No open lines',
      week: 'Week',
      month: 'Month',
      halfYear: 'Half-year',
      year: 'Year',
      period: 'Period',
    },
    calculator: {
      compoundInterest: 'Compound interest',
      mortgage: 'Mortgage',
      financialFreedom: 'Financial freedom',
      travel: 'Travel',
      pleasantPurchases: 'Pleasant purchases',
      dreamCar: 'Dream car',
      bestParent: 'Be the best parent',
      partnerCalculator: 'Partner calculator',
      currency: 'Currency',
      ruble: 'ruble',
      dollar: 'dollar',
      euro: 'euro',
      buyTradingSystem: 'Buy a trading system',
      downloadPdf: 'Download PDF',
      downloadPng: 'Download PNG',
      detailedCalculation: 'Detailed calculation',
      fillAllFields: 'Fill in all fields to view the detailed calculation',
      investmentTotals: 'Investment totals',
      totalResult: 'Total',
      instructions: 'Instructions',
      year: 'Year',
      month: 'Month',
      date: 'Date',
      capitalAtTermStart: 'Capital at the beginning of the term',
      startingCapitalAtTermStart: 'Starting capital at the beginning of the term',
      additionalInvestments: 'Additional investments',
      additionalInvestmentsAmount: 'Additional investment amount',
      profit: 'Profit',
      total: 'Total',
      investmentAmount: 'Investment amount',
      monthlyProfit: 'Monthly profit',
      monthlyProfitCar: 'Monthly profit',
      mortgagePayment: 'Mortgage payment amount',
      deposit: 'Deposit',
      carLoanPayment: 'Car loan payment',
      moneyInAccount: 'Money in the account',
      totalAmount: 'Total amount',
      level: 'Level',
      levelNumber: 'Level {{count}}',
      salesAmount: 'Sales amount',
      mortgageDescription: 'Income from the trading system will cover <br /> your monthly mortgage payment.',
      monthlyMortgagePayment: 'ENTER YOUR MONTHLY MORTGAGE PAYMENT',
      monthlyInvestmentAmount: 'ENTER THE AMOUNT YOU CAN INVEST MONTHLY',
      immediateDeposit: 'HOW MUCH CAN YOU INVEST RIGHT AWAY',
      mortgageResult:
        'If you deposit an amount into the account every month, the income from the trading system will cover the monthly mortgage payment in:',
      monthUnit_one: '{{count}} month',
      monthUnit_few: '{{count}} months',
      monthUnit_many: '{{count}} months',
      monthUnit_other: '{{count}} months',
      yearUnit_one: '{{count}} year',
      yearUnit_few: '{{count}} years',
      yearUnit_many: '{{count}} years',
      yearUnit_other: '{{count}} years',
      durationWithYears: '{{years}} and {{months}}',
      dreamCarDescription: 'Buy the car of your dreams! <br /> Income from trading systems will cover all expenses.',
      carPrice: 'enter the price of the car you want to buy',
      carPurchaseDeposit: 'To buy it, you need to deposit',
      instructionStage: 'Stage {{count}}',
      mortgageInstruction1: 'Buy a trading system',
      mortgageInstruction2: 'Deposit {{amount}}',
      mortgageInstruction3: 'Build up a deposit of {{amount}} from monthly profit',
      mortgageInstruction4: 'Using monthly profit of {{profit}}, pay a mortgage of {{payment}}',
      mortgageInstructionTotal:
        'By generating a profit of {{profit}}, the trading system fully covers the mortgage payment, so you no longer need to pay it out of pocket',
      carInstruction1: 'Buy USDT for {{amount}}',
      carInstruction2: 'Buy the required number of trading systems',
      carInstruction3: 'Deposit {{amount}}',
      carInstruction4: 'Buy a car on a one-year loan with a 20% down payment',
      carInstruction5:
        'Receive a monthly income of {{income}}, pay {{payment}} toward the car loan, and add the rest to the trading-system balance',
      carInstruction6: 'Make all 12 monthly payments using income from the trading system',
      carTotal1: 'We kept the {{deposit}} deposit and bought a car',
      carTotal2: 'Receive a monthly income of {{income}}',
      carTotal3: 'You can plan your next purchase or live on investment income!',
      blockDescription1: 'This tool helps you calculate an investment strategy using our trading systems!',
      blockDescription2:
        'Here you will learn how to build a pension, save for your children’s future, travel the world every year on passive income, and much more!',
      blockDescription3: 'This tool can be used both personally and to support sales to your clients',
      fillChartFields: 'Fill in all fields to display the chart',
      fillDiagramFields: 'Fill in all fields to display the diagram',
      compoundInterestTitle: 'Compound interest',
      compoundInterestDescription:
        'Compound interest is interest accrued on the initial investment and on the interest accumulated during previous periods. It assumes that the income received is reinvested.',
      startingCapital: 'Starting capital',
      investmentTerm: 'Investment term',
      additionalMonthlyInvestments: 'Additional monthly investments',
      withdrawProfitMonthly: 'Withdraw profit monthly',
      reinvestMonthly: 'Reinvest monthly',
      monthUpper: 'MONTH',
      yearUpper: 'YEAR',
      monthlyRate: 'Monthly rate',
      investmentResult: 'Investment result',
      financialFreedomTitle: 'Financial freedom',
      financialFreedomDescription:
        'Want to pursue self-fulfillment? Start living for yourself. <br /> $1,000 in your account today — $110,000 in 10 years.',
      oneTimeInvestment: 'One-time investment',
      accountAfterTime: 'in {{duration}}, your account balance will be',
      monthlyIncomeIs: 'monthly income will be',
      averageMonthlyReturn: 'at an average monthly return of 4%',
      monthlyContributions: 'Monthly contributions',
      investmentTermLower: 'investment term',
      yearsUpper: 'YEARS',
      bestParentDescription:
        'Income from trading systems will help you send your child to any university in the world or fulfil their other dreams.',
      travelDescription:
        'Travel with peace of mind while trading systems generate profit. <br /> You deserve a vacation!',
      annualTravelAmount: 'Enter the amount you want to spend on travel each year',
      requiredDeposit: 'To receive this income, you need to deposit',
      pleasantPurchasesTitle: 'Pleasant purchases',
      pleasantPurchasesDescription:
        'Buy what you want without spending your own funds. <br /> Thanks to income from trading systems.',
      equipmentCost: 'Enter the cost of the equipment',
      partnerCalculatorTitle: 'Partner calculator',
      partnerCalculatorDescription:
        'The partner calculator helps you estimate income from each partner in your first line. Enter your level and test different sales scenarios to see how much you can earn from each line in your structure.',
      careerLevel: 'your career level',
      yourSales: 'Your sales',
      salesAtLevel: 'Sales at level {{level}}',
      totalSales: 'Total sales amount',
      travelAmount: 'Travel amount',
      purchaseAmount: 'Purchase amount',
      buyKeeper: 'Buy the Keeper trading system',
      depositAmount: 'Deposit {{amount}}',
      addMonthly: 'Add {{amount}} each month',
      giveAccessToChildren: 'In {{duration}}, give the account access to your children',
      educationTotal:
        'In {{duration}}, thanks to compound interest and monthly contributions of {{contribution}}, we will accumulate {{total}} with a monthly income of {{income}}',
      buyTradingSystemInstruction: 'Buy a trading system',
      monthlyProfitForCompound: 'Receive monthly profit and leave it in the account to build compound interest',
      balanceAfterTwelveMonths: 'After 12 months, the account balance will be {{amount}}',
      vacationTotal:
        'With a deposit of just {{deposit}}, after 12 months of compound interest, we will accumulate {{profit}} in profit and be able to travel',
      monthlyProfitForPurchase: 'Receive monthly profit and leave it in the trading system to build compound interest',
      purchaseTotal:
        'With a deposit of just {{deposit}}, after 12 months of compound interest, we will accumulate {{profit}} in profit and be able to buy a new iPhone.',
      retireAfter: 'Retire in {{duration}}',
      financialFreedomTotal:
        'In {{duration}}, thanks to compound interest and monthly contributions of {{contribution}}, we will accumulate {{total}} with a monthly income of {{income}}',
      totalForYear: 'Total for the year',
    },
    cart: {
      title: 'Cart',
      empty: 'Your cart is empty',
      goToStore: 'Go to store',
      total: 'TOTAL:',
      pay: 'Pay',
      products: 'Products',
      confirmPayment: 'Confirm payment',
      close: 'Close',
      error: 'Error!',
      done: 'Done!',
      paymentSuccessful: 'Payment was successful',
      purchaseCompleted: 'Purchase completed',
      purchaseWillBeCredited: 'After the payment is confirmed, the product will be credited to your account',
      cancel: 'Cancel',
      confirm: 'Confirm',
      paymentMethod: 'Select a payment method',
      chooseCoin: 'Select a coin',
      coin: 'Coin',
      chooseNetwork: 'Select a network',
      cryptocurrencyNetwork: 'Cryptocurrency network',
      noPaymentNetworks: 'There are currently no payment networks available for this coin.',
      pleaseWait: 'Please wait.',
      invoiceCreated: 'Payment invoice created',
      amountDue: 'Amount due: {{amount}}',
      paymentPageCoinAndNetwork: 'On the payment page, you can select the coin and network you need',
      paymentConfirmedAutomatically: 'Payment is confirmed automatically, usually within a minute after the transfer',
      goToPaymentPage: 'Go to payment page',
      creatingInvoice: 'Creating invoice…',
      operationFailed: 'Unable to complete the operation. Please try again.',
      recalculationFailed: 'Unable to recalculate technical support',
      invoiceCreationFailed: 'Unable to create a payment invoice',
      receiptUploadFailed: 'Unable to upload the receipt. Please try again.',
      minimumPurchaseAmount: 'Minimum purchase amount: {{amount}}',
      receiptUploadError: 'Unable to upload the receipt',
      invalidFileType: 'Unsupported file type. Allowed: {{extensions}}',
      fileTooLarge: 'The file is larger than 10 MB.',
      uploadPaymentScreenshot: 'Upload a payment screenshot',
      sendPaymentToAddress: 'Send the amount to the specified address and click “I paid”',
      network: 'Network',
      wallet: 'Wallet',
      walletCopied: 'Wallet copied',
      amount: 'Amount',
      payByQr: 'Pay by QR code',
      receiptProcessing: 'Processing receipt. Please wait.',
      paid: 'I paid',
      quantity: 'Quantity: {{count}}',
      technicalSupportMonths: 'Technical support months: {{count}}',
      purchaseCommission: 'Purchase commission:',
      paymentUnavailable: 'Payment is temporarily unavailable. Please try again later.',
      warning: 'Warning!',
      cryptoAddressWarning: 'This address is intended only for {{coin}} transfers via the {{network}} network.',
      noSmartContractTransfers:
        'Do not send smart-contract transfers, {{baseCoin}}, or any other cryptocurrency to it. Such transfers will not be credited!',
      transferExactAmount:
        'Transfer the exact amount (product amount) of {{coin}} to the specified address in a single transaction.',
      amlMonitoring: 'Cryptocurrency deposits are monitored in accordance with our AML programme.',
      receiptSample: 'RECEIPT SAMPLE',
      withdrawalDetails: 'Withdrawal details',
      withdrawalCompleted: 'Withdrawal completed',
      account: 'Account',
      fundingAccount: 'Funding account',
      networkType: 'Network type',
      commission: 'Commission',
      time: 'Time',
      walletAddress: 'Wallet address',
      transactionHash: 'Transaction hash (TXID)',
      receiptSampleAbove: 'The receipt sample is shown above',
      receiptRequirementDate: '1. Transaction date and time',
      receiptRequirementHash: '2. Transaction HASH or TXID',
      receiptRequirementAmount: '3. Amount',
      receiptRequirementWallet: '4. Wallet address to which the funds were sent',
      receiptAnyFormat: 'The receipt may be in any format; the main requirement is to include all four data types',
      serverUpgrade: 'Upgrade',
      serverProlongation: 'Renewal',
      numberOfMonths: 'Number of months',
      termToIssue: 'term to purchase',
      numberOfProducts: 'Number of products',
      dependsOnSystems: 'depends on the number of systems',
      subscriptionTerm: 'subscription term',
      numberOfServers: 'Number of servers',
      serversToAdd: 'number of servers to add',
      oneServer: 'one server',
      oneSubscription: 'one subscription',
      tariffUpgrade: 'Tariff upgrade: {{from}} → {{to}}',
      tariffUpgradePrefix: 'Tariff upgrade:',
      serverTariffUpgrade: 'Server tariff upgrade',
      serverId: 'Server ID {{id}}',
      durationDiscount: 'Term discount {{percent}}% (without discount — {{amount}})',
      technicalSupportRecalculation:
        'If you have more than one trading system, the technical support cost will be recalculated automatically based on their number',
      quantityLabel: 'Quantity',
    },
    products: {
      addedToCart: 'Product added to cart successfully',
      addToCart: 'Add to cart',
      pay: 'Pay',
      sentToPartner: 'Product sent to partner successfully',
      partnerEmailOrLoginError: 'Incorrect partner email or username',
      tryAgain: 'Try again',
      enterPartnerEmailOrLogin: 'Enter the partner’s email or login',
      sendToPartner: 'Send to partner',
      activate: 'Activate',
      ourProducts: 'Our products',
      purchasedProducts: 'Purchased products',
      tradingSystems: 'Trading systems',
      technicalSupport: 'Technical support',
      activeUntil: 'Active until',
      inactive: 'Inactive',
      renewSupport: 'Renew support',
      installationInstructions: 'Installation instructions',
      totalQuantity: 'Total quantity: {{count}}',
      activationRequired: 'Product activation is required',
      subscriptionAdded: 'Subscription added to cart',
      subscriptionAddFailed: 'Unable to add subscription to cart',
      perMonth: '/ month',
      subscriptionActive: 'Active from {{from}} to {{to}}',
      telegramLinked: 'Telegram linked',
      relink: 'Relink',
      unlinkTelegram: 'Unlink {{username}}? Signals will no longer be sent to this Telegram account.',
      unlink: 'Unlink',
      linkTelegram: 'Link Telegram',
      subscriptionExpired: 'Subscription expired {{date}}',
      renew: 'Renew',
      applyForInstallation: 'Request installation?',
      installationInstructionsTitle: 'Installation instructions',
      videoInstruction: 'Video instruction',
      open: 'Open',
      pdfInstruction: 'PDF instruction',
      download: 'Download',
      mentorHelp: 'Mentor assistance',
      goTo: 'Go to',
      later: 'Later',
      yes: 'Yes',
      skip: 'Skip',
      submitApplication: 'Submit application',
      activeOne: 'Active product',
      activeFew: 'Active products',
      activeMany: 'Active products',
      archivedOne: 'Archived product',
      archivedFew: 'Archived products',
      archivedMany: 'Archived products',
      monthsOne: '{{count}} month',
      monthsFew: '{{count}} months',
      monthsMany: '{{count}} months',
      inCartFor: 'In cart: {{period}}',
      subscriptionUnavailable: 'The signals subscription is currently unavailable',
      currentTelegram: 'current Telegram account',
      activeStatus: 'Active',
      activeStatusWithCount: 'Active: {{count}}',
      archivedStatus: 'Archived',
      archivedStatusWithCount: 'Archived: {{count}}',
    },
    vps: {
      active: 'Active',
      awaitingPayment: 'Awaiting payment',
      provisioning: 'Provisioning',
      expired: 'Subscription expired',
      blocked: 'Blocked',
      error: 'Error',
      unknown: 'Unknown',
      deleted: 'Deleted',
      expiredNotice:
        'The subscription has expired. Renew it within {{days}} days, otherwise the server and its data will be deleted. You can still log in, but the desktop will be replaced by a renewal prompt.',
      blockedNotice: 'Server access has been blocked by an administrator. Please contact support.',
      permanent: 'Permanent',
      gateway: 'GATEWAY',
      activeServers: 'Active servers',
      plan: 'Plan',
      issued: 'Issued',
      paidUntil: 'Paid until',
      accessData: 'Access details',
      upgrade: 'Change tariff',
      renew: 'Renew',
      total: 'Total:',
      noActiveServers: 'You have no active servers',
      tariffPlans: 'Tariff plans',
      faq: 'FAQ & Help',
      generalQuestions: 'General questions',
      serviceOperation: 'How the service works',
      tradingTerminals: 'Trading terminals',
      performance: 'Performance',
      security: 'Security',
      technicalSupport: 'Technical support',
      needConsultation: 'Need a consultation?',
      consultationText: 'Our specialists will help you select the optimal server for your needs.',
      contactUs: 'Contact us',
      popular: 'Popular',
      server: 'Server',
      order: 'Order',
      select: 'Select',
      login: 'LOGIN',
      password: 'PASSWORD',
      ipAddress: 'IP ADDRESS',
      downloadAccessFile: 'Download VPS access file',
      accessHint:
        'Use the convenient quick-access feature for VPS. Click the button above, run the downloaded file and enter the VPS password',
      serverRenewal: 'Server renewal',
      tariff: 'TARIFF',
      amountDue: 'Amount due',
      renewVps: 'Renew VPS',
      serverUpgrade: 'Server upgrade',
      loadingTariffs: 'Loading available tariffs…',
      unavailableUpgrades: 'Unable to load available upgrades. Please try again later.',
      maximumTariff: 'The server is already on the highest tariff.',
      surcharge: 'Surcharge',
      selectTariff: 'Select a tariff',
      surchargeHint: 'The surcharge is calculated for the remaining {{days}} days of the paid period',
      upgradeVps: 'Change tariff',
      renewalRequiredHint: 'The minimum purchase amount is ${{amount}} and the upgrade surcharge is not enough. To place the order, renew the server for at least {{period}}',
      renewalTotal: 'Total: ${{surcharge}} upgrade + ${{renewal}} renewal',
      renewalMinHint: 'The minimum payment amount is ${{amount}}, so the shortest renewal term that reaches it has been selected: {{period}}. You can extend the term.',
      productAddedToCart: 'Product successfully added to the cart',
      renewalAddedToCart: 'The server renewal was successfully added to the cart',
      upgradeAddedToCart: 'The server upgrade was successfully added to the cart',
      terminalOne: 'terminal',
      terminalFew: 'terminals',
      terminalMany: 'terminals',
      tariffTooltips: {
        standard:
          'Basic tariff for one MT4 or MT5 trading terminal. Suitable for beginners and investors using one trading system. An optimal choice for stable daily work.',
        pro: 'A tariff for active users working with several MT4 and MT5 terminals at once. Supports up to 3 terminals and convenient management of several trading systems on one server.',
        business:
          'An optimal solution for experienced traders and investors using several strategies. Supports up to 5 MT4 and MT5 terminals for an expanded portfolio of trading systems.',
        enterprise:
          'A professional high-load tariff. Supports up to 8 MT4 and MT5 terminals and provides maximum flexibility for multiple strategies and investment areas.',
        ultimate:
          'The maximum tariff for large-scale work with trading systems. Supports up to 15 MT4 and MT5 terminals for professionals managing many strategies and investment projects.',
      },
    },
    vpsFaq: {
      s1q1: {
        title: 'What is FT Server?',
        content:
          'FT Server is a remote Windows server that keeps MetaTrader 4 and MetaTrader 5 trading terminals running around the clock, independently of your computer.',
      },
      s1q2: {
        title: 'What is FT Server for?',
        content:
          'FT Server keeps trading terminals running continuously even when your computer is off or your internet connection or electricity is unavailable.',
      },
      s1q3: {
        title: 'Who is FT Server for?',
        content: 'Traders, investors, and owners of trading robots (Expert Advisors).',
      },
      s1q4: {
        title: 'Does my computer need to stay on?',
        content:
          'No. After launching the terminals on FT Server, you can turn off your computer or close the connection window. The terminals and trading robots will continue running on the server around the clock.',
      },
      s1q5: {
        title: 'Will FT Server work without home internet or electricity?',
        content:
          'Yes. FT Server runs in a professional data center and does not depend on your computer, home internet connection, or power supply.',
      },
      s1q6: {
        title: 'Do I need special technical knowledge?',
        content: 'No. FT Server is ready to use, and specialists can help you connect if necessary.',
      },
      s2q1: {
        title: 'What will I receive after payment?',
        item1: 'a ready-to-use connection file (.rdp) with the server address',
        item2: 'login',
        item3: 'password',
        item4: 'connection instructions',
      },
      s2q2: {
        title: 'How long does activation take?',
        content: 'The server is usually ready within a few minutes after payment.',
      },
      s2q3: {
        title: 'Which operating system does the server use?',
        content: 'Windows Server 2025. The server is ready to use immediately after connection.',
      },
      s2q4: {
        title: 'Can I connect from a Mac?',
        content: 'Yes, using Windows App (formerly Microsoft Remote Desktop).',
      },
      s2q5: {
        title: 'Can I connect from a phone?',
        content: 'Yes, using an RDP client: Windows App on iPhone/iPad or Remote Desktop on Android.',
      },
      s2q6: {
        title: 'Can I connect from multiple devices?',
        content:
          'Yes, from a desktop, laptop, tablet, or smartphone. You connect to the same desktop from any device; your terminals are not duplicated and continue running.',
      },
      s3q1: { title: 'Which platforms are supported?', item1: 'MetaTrader 4 (MT4)', item2: 'MetaTrader 5 (MT5)' },
      s3q2: {
        title: 'Do I need to install MetaTrader?',
        content: 'No. The terminals are already installed and ready to use.',
      },
      s3q3: {
        title: 'Can I run multiple terminals?',
        content: 'Yes. The number of terminals that can run simultaneously depends on the selected tariff.',
      },
      s3q4: {
        title: 'Which tariff should I choose?',
        item1: 'Standard for 1 terminal — for working with one MT4 or MT5 terminal',
        item2: 'Pro for up to 3 terminals — for working with several trading systems simultaneously',
        item3: 'Business for up to 5 terminals — for multiple strategies',
        item4: 'Enterprise for up to 8 terminals — for professional high-load use',
        item5: 'Ultimate for up to 15 terminals — for large-scale work with many terminals',
      },
      s4q1: {
        title: 'Why is FT Server better than a home computer?',
        item1: 'runs 24/7',
        item2: 'high stability',
        item3: 'minimal latency',
        item4: 'fast internet connection',
      },
      s4q2: {
        title: 'What is low latency?',
        content:
          'It is the minimum data-transfer time to the trading server, which helps trading operations execute faster.',
      },
      s4q3: {
        title: 'Where are the servers located?',
        content: 'The servers are hosted in professional data centers with reliable infrastructure.',
      },
      s5q1: {
        title: 'How secure is FT Server?',
        content: 'Each user receives a separate account with individual login details. The connection is encrypted.',
      },
      s5q2: {
        title: 'Can anyone else access my server?',
        content:
          'No. Your account, files, settings, and trading sessions are fully isolated; other users cannot access them.',
      },
      s5q3: {
        title: 'Will my data remain after a restart?',
        content:
          'Yes. Your terminals, Expert Advisors, indicators, settings, and files are retained. After a scheduled server restart, trading terminals must be started again; we notify you about such maintenance in advance.',
      },
      s6q1: {
        title: 'Do you help with connection?',
        content: 'Yes. Specialists will help you connect to the server and answer your questions.',
      },
      s6q2: {
        title: 'Do you provide setup assistance?',
        content: 'Yes. If necessary, specialists will help with the initial setup and getting started.',
      },
    },
    auth: {
      signInTitle: 'Sign in',
      resetPasswordTitle: 'Password recovery',
      signIn: 'Sign in',
      signInToAccount: 'Sign in to account',
      register: 'Registration',
      registerAction: 'Register',
      haveAccount: 'Already have an account?',
      noAccount: 'Don’t have an account?',
      continue: 'Continue',
      confirm: 'Confirm',
      back: 'Go back',
      returnToLogin: 'Return to sign in?',
      email: 'Email',
      login: 'Login',
      password: 'Password',
      repeatPassword: 'Repeat password',
      partnerCode: 'Partner code',
      emailConfirmationCode: 'Email confirmation code',
      confirmationCode: 'Confirmation code',
      confirmationMethod: 'Confirmation method',
      confirmByEmail: 'By email',
      confirmByGoogle: 'Via Google Authenticator',
      clearData: 'Clear data',
      forgotPassword: 'Forgot your password?',
      passwordSent: 'A new password has been sent to {{email}}',
      waitForCode: 'Please wait for the confirmation code: {{count}} sec.',
      signInConsent:
        'By signing in, you accept the terms in our documents and confirm that you are at least 18 years old.',
      registrationConsent:
        'By registering, you accept the terms in our documents and confirm that you are at least 18 years old.',
      timeWarning: 'The time on your device is not synchronized. This may affect Google 2FA.',
      documents: {
        publicOffer: 'Public offer',
        privacyPolicy: 'Privacy policy',
        riskNotice: 'Risk notice',
        systemGuide: 'Software User Guide',
      },
      footer: {
        legalAddress: 'Legal address:',
        registrationNumber:
          'Quijano Chambers, P.O. Box 3159, Road Town, Tortola, British Virgin Islands, state registration number 2156676',
        riskTitle: 'Risk warning:',
        riskText:
          'Trading leveraged products such as CFDs involves a high level of risk. Do not trade or invest unless you fully understand the extent of your risk of loss. Always consider your level of experience, as improper investing may result in the loss of funds. If the associated risks are unclear to you, please seek independent advice from an external specialist.',
      },
      googleAuthenticator: {
        downloadTitle: 'Download Google Authenticator',
        downloadDescription: 'Download and install the Authenticator app on your phone, then link your account.',
        downloadIos: 'Download Google Authenticator (iOS)',
        downloadAndroid: 'Download Google Authenticator (Android)',
        connectTitle: 'Link Google Authenticator',
        connectInstructionTitle: 'Link Google Authenticator',
        openAndStart: 'Open the app and tap “Get started”',
        chooseAuthenticationMethod: 'Choose an authentication method',
        scanQrCode: 'Scan the QR code',
        enterKey: 'Enter the key',
        keyCopied: 'Key copied',
        done: 'Done',
        disconnectTitle: 'Unlink Google Authenticator',
        disconnectConfirmation: 'Are you sure you want to unlink Google Authenticator?',
        disconnect: 'Unlink',
        cancel: 'Cancel',
      },
      errors: {
        enterEmail: 'Enter your email',
        enterLogin: 'Enter your login',
        enterPassword: 'Enter your password',
        enterPartnerCode: 'Enter the referral code',
        enterConfirmationCode: 'Enter the confirmation code',
        enterEmailConfirmationCode: 'Enter the email confirmation code',
        repeatPassword: 'Repeat your password',
        invalidEmail: 'Invalid email address',
        emailLatinOnly: 'Email contains Latin characters',
        loginLatinOnly: 'Login must contain Latin characters only',
        loginLength: 'Login must be between {{min}} and 36 characters long',
        loginContainsAt: 'Login contains @',
        loginContainsSpaces: 'Login contains spaces',
        loginCharacters: 'Login may contain only Latin letters, numbers, and .-_! special characters',
        loginCharactersNoUppercase:
          'Login may contain only Latin letters, numbers, and .-_ special characters and must not contain uppercase characters',
        loginNoUppercase: 'Login must not contain uppercase characters',
        passwordCharacters: 'Password may contain only Latin letters, numbers, and !@#$%^&*()-+',
        registrationPasswordCharacters:
          'Password may contain only Latin letters, numbers, and the following special characters: % & ! ? # $ * + , . - + : @ _',
        passwordComplexity:
          'Password must contain at least 2 of 4: lowercase letters, uppercase letters, numbers, special characters',
        codeLength: 'The code must contain 6 to 9 characters',
        invalidCode: 'Invalid confirmation code',
        invalidCredentials: 'Invalid login or password',
        sendCodeError: 'Unable to send the email message',
        selectMethod: 'Select a confirmation method',
        emailTaken: 'Login or email is already in use',
        weakPassword: 'Password is too weak',
        invalidReferralCode: 'Invalid referral code',
        passwordsMismatch: 'Passwords do not match',
        referralLowercase: 'Referral code must contain at least one lowercase letter',
        referralUppercase: 'Referral code must contain at least one uppercase letter',
        referralDigit: 'Referral code must contain at least one digit',
        referralLength: 'The code must contain {{length}} characters',
      },
    },
    promo: {
      windowTitle: 'PROMOTIONS',
      learnMore: 'Learn more',
      materials: {
        title: 'Promotional materials',
        presentations: 'presentations',
        video: 'video',
        photos: 'photos',
        reviews: 'reviews',
        run: 'promotional campaigns',
      },
      summer: {
        imageAlt: 'The main giveaway is extended until 1 October',
        intro: 'Friends, we have extended our summer giveaway of valuable prizes from FT Holding Trade!',
        prizePlaces: '30 prize places —',
        prizePlacesDescription: 'for top tech and trading systems',
        period: 'Promotion period: 01.06.2026 — 01.10.2026',
        dontMissChance: 'Do not miss your chance!',
        conditionsTitle: 'ENTRY CONDITIONS:',
        participation: {
          lineOne: 'To enter the prize',
          lineTwo: 'giveaway, you need to:',
          description: 'Make 2 purchases or 2 sales of any trading systems during the giveaway period',
          buyTicket: '2 purchases = 1 ticket',
          sellTicket: '2 sales = 1 ticket',
          story: 'Also repost the story in your Telegram account and include a link to this channel at the bottom.',
          whatsapp: 'No Telegram Premium? You can post a story in WhatsApp and include a link to this channel',
        },
        prizeListTitle: 'Prize list:',
        prizeList: {
          1: '— MacBook Neo (5 pcs.)',
          2: '— iPhone 17 Pro Max (5 pcs.)',
          3: '— Samsung tablet (5 pcs.)',
          4: '— Apple Watch SE (5 pcs.)',
          5: '— AirPods Pro (5 pcs.)',
          6: '— Trading systems worth $650 (5 pcs.)',
        },
        applicationTitle: 'To apply for participation, you need to:',
        codeWord: 'send the code word “ЛЕТО” to the promotions department to receive an entry ticket',
        collectionStart: 'Entries open: 1 June 2026',
        sendApplications: 'Send applications here:',
        rulesTitle: 'GIVEAWAY RULES:',
        collection: 'Entry period:',
        collectionUntil: 'until 00:00 MSK inclusive',
        results: 'Results announcement:',
        resultsDate: '05.10.2026 at 18:00 MSK',
        zoomLink: 'the Zoom link will be sent to the support channel',
        finalTitle: 'Time will fly by. Become part of this season’s biggest community of traders',
        rules: {
          1: {
            before: 'To receive an entry ticket, you must subscribe to the company’s',
            link: 'main channel',
            after: 'until the giveaway ends.',
          },
          2: 'You may win only one item from the first prize category. If you win twice, the second prize will be redrawn.',
          3: 'Tickets for sales and purchases DO NOT COMBINE; they are counted separately. You must make 2 purchases OR 2 sales to receive 1 entry ticket.',
          4: 'Prizes will be drawn online using a randomizer.',
          5: 'You may not transfer or gift your tickets to other participants.',
          6: 'You may not change your Telegram username from the start of the giveaway until it ends.',
          7: 'Attendance on the live stream from your own personal account is MANDATORY. No one may attend on your behalf.',
          8: 'If multiple accounts, repeat registrations, or any other manipulation of the rules are discovered, the organisers reserve the right to disqualify the participant fully and refuse to issue prizes.',
          9: 'All prizes won, both gadgets and trading systems, are awarded strictly in their original form; exchanging gifts for their cash value is not available under this promotion.',
        },
      },
      server: {
        modalTitle: 'GIVEAWAY TO CELEBRATE THE LAUNCH OF FT SERVER!',
        modalText:
          'We are launching a new promotion for the first users of our new product, FT Server. Subscribe to a server and enter the giveaway for top prizes!',
        collectionDates: 'Entry period: 01.09.2026 — 01.12.2026',
        imageAlt: 'Giveaway to celebrate the launch of FT Server',
        intro: 'Friends, we have decided to launch a new promotion for the first users of our new product, FT Server',
        introAction: 'Subscribe to a server and enter the giveaway for top prizes!',
        infrastructure: {
          lineOne: 'New infrastructure',
          lineTwo: 'New opportunities',
          lineThree: 'Great prizes',
          descriptionOne: 'FT Server is built for the stable operation of trading terminals 24/7',
          descriptionTwo: 'To celebrate the launch, we are giving away three tech prizes among the first users',
        },
        collection: 'Entry period',
        results: 'Results announcement',
        resultsDate: '04.12.2026 at 17:00 MSK',
        dontMissChance: 'Do not miss your chance!',
        prizesTitle: 'WHAT IS AT STAKE?',
        conditionsTitle: 'ENTRY CONDITIONS',
        conditionsLead: 'Choose a plan and subscription period that meet the giveaway conditions:',
        startPlans: 'Standard 1 or Pro 3',
        advancedPlans: 'Business 5 or Enterprise 8 or Ultimate 15',
        twoYears: '2 YEARS',
        oneYear: '1 YEAR',
        eligiblePayment: 'Each eligible payment gives you 1 entry',
        howToParticipate: 'HOW TO ENTER',
        rulesTitle: 'GIVEAWAY RULES',
        finalTitle: 'Connect FT Server and claim your gifts',
        finalLineOne: 'Two months',
        finalLineTwo: 'will fly by!',
        participate: 'Enter the giveaway',
        chooseFtServer: 'Choose FT Server',
        prizes: {
          first: { place: '1ST PLACE', text: 'Win a new iPhone to monitor your trading systems at top speed' },
          second: {
            place: '2ND PLACE',
            title: '50% discount on an FT trading system',
            text: 'Available only when purchasing systems priced at $650. Your half-price gateway to automated trading',
          },
          third: {
            place: '3RD PLACE',
            title: 'FT Server',
            subtitle: 'for 15 terminals',
            text: 'Ultimate plan for 12 months. Maximum performance and uninterrupted operation of all terminals',
          },
        },
        steps: {
          first: {
            title: 'Purchase a subscription',
            lineOne: 'Standard 1 / Pro 3 — for 2 years.',
            lineTwo: 'Business 5 / Enterprise 8 / Ultimate 15 — for 1 year.',
          },
          second: { title: 'Send the code word', text: 'FT SERVER to @gtgcontrol' },
          third: {
            title: 'Receive your entry ticket',
            text: 'Receive your official ticket and wait for the giveaway finale.',
          },
        },
        rules: {
          left: {
            1: 'The giveaway includes FT Server subscriptions paid for between 1 September and 1 December 2026',
            2: 'For Standard 1 and Pro 3, eligibility requires purchasing a server subscription for at least 2 years',
            3: 'For Business 5, Enterprise 8, and Ultimate 15, eligibility requires purchasing a server subscription for at least 1 year',
            4: 'Each payment that meets the conditions gives 1 giveaway entry',
            5: 'Combining separate payments or making a partial payment is not accepted',
            6: 'A user becomes a giveaway participant after receiving an official entry ticket upon meeting all promotion conditions',
            7: 'The giveaway will take place live on 4 December at 17:00 MSK',
          },
          right: {
            1: 'Winners are selected at random from participants who received an entry ticket.',
            2: 'To receive a prize, a participant must be present on the live stream during the giveaway',
            3: 'If funds are refunded, participation in the promotion is automatically cancelled',
            4: 'No cash alternative is available for prizes',
            5: 'The organiser may replace a prize with one of equivalent value if the stated model is unavailable from the supplier',
            6: 'The organiser reserves the right to change the dates, conditions, and procedure of the promotion in the event of force majeure',
          },
        },
      },
    },
    support: {
      title: 'Support',
      searchPlaceholder: 'Enter your question',
      nothingFound: 'Nothing found',
      popularTopics: 'Popular topics',
      chatWithSupport: 'Support chat',
      askQuestion: 'Ask a question',
      followUs: 'Follow us!',
      newsDescription: 'Stay up to date with all the news',
      back: 'Back',
      nextArticle: 'Next article',
      relatedArticles: 'More on this topic',
      article: {
        apiKeysQuestion: 'Where to get API keys',
        apiKeysStepOne:
          'First, register on this exchange. Then go to the API settings as shown in the screenshot below.',
        apiKeysStepTwo: 'Enter a name for your API key and click “API created”.',
        apiKeysStepThree:
          'In the pop-up window, click “Get code”. It will be sent to the email address registered with your Binance account.',
        apiKeysStepFour:
          'Enter it in the field on the left and enter your two-factor authentication code. We recommend using two-factor authentication for security. Then click “Send”. Your API Key and Secret key will appear. Save these details: a lost Secret key cannot be recovered.',
        huobiQuestion: 'Creating an API key on Huobi',
        huobiStep:
          'Go to the Huobi website and sign in. Then click the profile icon in the upper-right corner and select “API Management”.',
        binanceQuestion: 'How to create an API key on Binance',
      },
    },
    speedTest: {
      title: 'INTERNET SPEED',
      download: 'DOWNLOAD',
      upload: 'UPLOAD',
      retry: 'RETRY',
      ratings: { 1: 'VERY SLOW', 2: 'SLOW', 3: 'NORMAL', 4: 'GOOD', 5: 'EXCELLENT' },
    },
    academy: { title: 'Academy', open: 'Open' },
    currencyRates: { loadingError: 'Failed to load quotes', reload: 'Reload', loading: 'Loading...' },
    breadcrumbs: { partner: 'Partner', marketing: 'marketing' },
    news: { title: 'News', important: 'Important news' },
    p2p: {
      identityVerification: 'Identity verification',
      higherInStructure: 'Higher in the hierarchy',
      lowerInStructure: 'Lower in the hierarchy',
      joined: 'Joined',
      country: 'Country',
      email: 'Email',
    },
    shared: {
      referralLink: 'Referral link',
      decrease: 'Decrease',
      increase: 'Increase',
      linkCopied: 'Link copied',
      no: 'No',
      connectGoogleAuthenticator: 'Connect Google Authenticator',
      valueOfMax: '{{value}} of {{max}}',
    },
    apiErrors: {
      generic: 'Unable to complete the action. Please try again.',
      server: 'Internal server error. Please try again later.',
      unavailable: 'The service is temporarily unavailable. Please try again later.',
      network: 'Unable to connect to the server. Check your internet connection.',
      secure: 'Unable to establish a secure connection. Refresh the page.',
      weak: 'Weak connection. Please try again.',
      tooLarge: 'The data volume is too large.',
      tooMany: 'Too many requests. Please wait a minute.',
      banned: 'Access is temporarily restricted because of too many requests. Try again in {{seconds}} sec.',
      newVersion: 'A new version of the account area is available. The page will refresh.',
      loginRequired: 'Sign in to your account.',
      sessionEnded: 'Your session has ended. Sign in again.',
      sessionExpired: 'Your session has expired. Sign in again.',
      accessCheckFailed:
        'Unable to verify access to your account. Sign in again. If you cannot sign in, contact support.',
      validation: 'Check the entered data.',
      loginExpired: 'The sign-in time has expired. Enter your login and password again.',
      registry: {
        account: {
          progressUnavailable: 'Progress data is currently unavailable.',
          statisticsUnavailable: 'Statistics are currently unavailable.',
        },
        common: {
          wrongConfirmationCode:
            'Invalid confirmation code. Enter your login and password again and request a new code.',
          actionRefresh: 'Unable to complete the action. Refresh the page.',
        },
        validation: {
          required: 'Required field',
          invalidFormat: 'Invalid characters or format',
          tooShort: 'The value is too short',
          tooLong: 'The value is too long',
          invalid: 'Invalid value',
          integer: 'Enter an integer',
          number: 'Enter a number',
          belowMinimum: 'The value is below the allowed minimum',
          aboveMaximum: 'The value is above the allowed maximum',
          selectFromList: 'Select a value from the list',
        },
        auth: {
          enterCredentials: 'Enter your login and password',
          securityUnavailable: 'Unable to load the account security settings. Contact support.',
          startFailed: 'Unable to start signing in. Please try again.',
          continueFailed: 'Unable to continue signing in. Please try again or contact support.',
          sendCodeFailed: 'Unable to send the code. Please try again.',
          sendSmsFailed: 'Unable to send an SMS with the code. Please try again.',
          completeFailed: 'Unable to complete sign-in. Please try again.',
          signInFailed: 'Unable to sign in. Contact support.',
          codeResent:
            'The code was sent again. The password entered during the first registration attempt will be used to sign in.',
          emailOrLoginTaken: 'Email or login is already in use',
          weakPassword:
            'The password is too weak. Use at least two character types: digits, uppercase and lowercase letters, or special characters.',
          referralNotFound: 'Referral code not found',
          registrationFailed: 'Unable to register. Please try again later.',
          invalidEmail: 'Invalid email',
          invalidEmailOrCode: 'Invalid email or code. If the account is already confirmed, sign in.',
          confirmEmailFailed: 'Unable to confirm the email. Please try again later.',
          emailConfirmed: 'Email confirmed. Sign in to your account.',
          expiredEmailCode: 'Invalid email or code. If more than 5 minutes have passed, request a new code.',
          sendConfirmationFailed: 'Unable to send the confirmation code. Please try again later.',
          methodUnavailable: 'This confirmation method is not connected. Choose another method.',
          invalidOrExpiredCode: 'Invalid or expired code',
          accountUnconfirmed: 'Account not confirmed',
          userNotFound: 'User not found',
          confirmEmailToSignIn: 'Confirm your email to sign in',
        },
        cart: {
          empty: 'Your cart is empty.',
          insufficientFunds: 'Insufficient balance. Add funds to pay for the order.',
          partialActivation:
            'Payment was successful, but some products were not activated. Activate them under Purchased Products or contact support.',
          manualDisabled: 'Wallet transfer payments are disabled.',
          paymentAssetUnavailable: 'The selected network or coin is unavailable. Choose another one.',
          coinsbuyDisabled: 'Coinsbuy payments are disabled.',
          coinsbuyUnavailable: 'Coinsbuy payments are temporarily unavailable. Choose another payment method.',
          coinsbuyCreateFailed: 'Unable to create a Coinsbuy payment. Please try again later.',
          paymentCreateFailed: 'Unable to create the payment. Try again later or choose another method.',
          invoiceUnavailable: 'The invoice was not found or has already been processed.',
          emptyFile: 'The file is empty. Choose another file.',
          fileTooLarge: 'The file is too large. Try uploading it as a file.',
          tariffUnavailable: 'The plan is unavailable. Refresh the plan list.',
          currentTariffUnknown: 'Unable to determine the server’s current plan. Contact support.',
          upgradeInCart:
            'An upgrade for this server is already in the cart. Remove it from the cart to choose another plan.',
          productUnavailable: 'The product is no longer available.',
          addFailed: 'Unable to add the item to the cart. Please try again.',
          itemRemoved: 'The item has already been removed from the cart.',
          duplicateRows: 'This item has multiple rows in the cart. Refresh the cart and select the required row.',
          quantityFailed: 'Unable to change the quantity. Please try again.',
          subscriptionQuantity:
            'A subscription is purchased as one item. To change the term, remove it and add it again.',
          renewalQuantity: 'For renewals, change the term in months rather than the quantity.',
          minSignalsMonths: 'The minimum signals subscription term is 3 months.',
          renewalTermInvalid: 'This renewal term is not allowed together with a tariff upgrade.',
          minAmount: 'The minimum purchase amount is ${{amount}}.',
        },
        confirmation: {
          settingsUnavailable: 'Unable to load the security settings. Refresh the page.',
          addPhoneFirst: 'Add a phone number to your profile first.',
          phoneCodeFailed: 'Unable to send the code. Phone protection may already be enabled—refresh the page.',
          requestNewCode: 'Invalid or expired code. Request a new one.',
          disablePhoneFailed: 'Unable to disable phone protection. Refresh the page.',
          connectGoogleFailed: 'Unable to connect Google Authenticator. It may already be connected—refresh the page.',
          googleCodeInvalid: 'Invalid code. Make sure your phone time is set automatically and enter a new code.',
          disableGoogleFailed: 'Unable to disconnect Google Authenticator. Refresh the page.',
          googleNotConnected: 'Google Authenticator is not connected.',
          invalidCode: 'Invalid code',
          telegramOtherAccount: 'Another Telegram ID is already linked to your account.',
          telegramConnected: 'Telegram is already connected.',
          telegramIdUsed: 'This Telegram ID is already registered.',
          telegramConnectFailed: 'Unable to connect Telegram. Please try again later.',
          telegramBonusFailed: 'Telegram was connected, but the bonus was not credited. Contact support.',
          telegramAuthFailed: 'Unable to authorize with Telegram. Please try again.',
          telegramAuthCancelled: 'Telegram authorization was cancelled.',
        },
        content: {
          eventNotFound: 'Event not found.',
          newsNotFound: 'News article not found.',
          supportSectionNotFound: 'Section not found.',
          supportArticleNotFound: 'Article not found.',
        },
        finance: {
          historyUnavailable: 'Unable to load the transaction history.',
          cancelFailed: 'Unable to cancel the transaction. Refresh the history: its status may have changed.',
          balanceUnavailable: 'Unable to load the balance.',
          walletAndNetwork: 'Specify a wallet and network',
          minimumAmount: 'The amount must be an integer of at least 30',
          withdrawalFailed: 'Unable to create the withdrawal request. Please try again later.',
          withdrawalUnavailable:
            'Unable to create the request: insufficient funds or the selected network is unavailable.',
        },
        partner: {
          structureUnavailable: 'Unable to load the structure.',
          referralUnavailable: 'The referral link is unavailable.',
          academyLoadFailed: 'Unable to load Academy data.',
          academyUnavailable: 'Academy data is unavailable.',
          profileUnavailable: 'The partner profile is unavailable.',
          purchasesForbidden: 'You do not have access to this partner’s purchases.',
          materialNotFound: 'Material not found.',
        },
        products: {
          activationFailed: 'Unable to activate the product. Try again or contact support.',
          transferFailed: 'Unable to transfer the product. Check that the partner is in your structure.',
        },
        profile: {
          dataUnavailable: 'Unable to load the data. Refresh the page.',
          deleteFailed: 'Unable to delete the account. Please try again later.',
          alreadyDeleted: 'The account has already been deleted.',
          passwordSessionExpired: 'Unable to change the password. Sign in again and retry.',
          passwordInvalid:
            'The current password is incorrect, or the new password is too weak or contains unsupported characters (? , . : _).',
          passwordFailed: 'Unable to change the password. Please try again later.',
          profileUnavailable: 'Unable to load the profile. Refresh the page.',
          phoneProtected: 'Changes saved. The phone number cannot be changed while phone protection is enabled.',
          saveFailed: 'Unable to save the changes. Please try again.',
          photosTooLarge: 'The photos are too large. Reduce their size and try again.',
          documentsFailed:
            'Unable to submit the documents. The application may already be under review or verification may be complete.',
          verificationUnavailable: 'Unable to retrieve the verification status.',
          securityUnavailable: 'Unable to retrieve the security settings.',
          linksUnavailable: 'Unable to load the links.',
          addLinkFailed: 'Unable to add the link.',
          linkNotSaved: 'The link was not found or was not saved. The list has been refreshed.',
        },
        servers: {
          provisioningFailed: 'Server provisioning failed. Contact support.',
          tariffDiscontinued: 'This plan is no longer available for sale. Contact support.',
          renewalFailed: 'Unable to renew the server. Please try again.',
          passwordFailed: 'Unable to change the password. Please try again later.',
          newPasswordFailed: 'Unable to retrieve the new password. Try again later or contact support.',
          passwordNotSaved: 'The server password may have changed but was not saved. Contact support.',
          insufficientRenewalFunds: 'Insufficient funds: {{price}} is required for renewal. Add funds to your balance.',
        },
      },
    },
    security: {
      chooseConfirmationMethod: 'Select a confirmation method',
      confirmationMethod: 'Confirmation method',
      choose: 'Select',
      resendAfter: 'Resend in {{seconds}} sec.',
      confirmation: 'Confirmation',
      protectAccount: 'Complete the following check to protect your account',
      authenticationCode: 'Authentication code',
      codeSentToEmail: 'Enter the code we sent to your email',
      enterCode: 'Enter the code',
      invalidCode: 'Invalid confirmation code',
      resendWithSeconds: 'Resend ({{seconds}} sec.)',
      resend: 'Resend',
      changeConfirmationMethod: 'Change confirmation method',
      confirm: 'Confirm',
    },
  },
};

export default en;
